'use client';
import Sidebar from '@/components/Sidebar';

export default function AppShell({ children }) {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="flex-1 lg:ml-[250px]">
        {children}
      </main>
    </div>
  );
}